import { useState, useCallback, useRef } from 'react';
import { AnnotationsState } from './AnnotationsState';
import { AnnotationRequests } from '../../../requests/annotation/AnnotationRequests';

export function useAnnotationsState() {
  const [state, setState] = useState(new AnnotationsState());

  const getAnnotations = useCallback(
    async (page: number = 1, words: string = '', signal?: AbortSignal) => {
      setState((prevState) => prevState.setRequestLoading());

      try {
        const result = await AnnotationRequests.getUserAnnotations(
          page,
          words,
          signal
        );
        if (signal && signal.aborted) return;
        setState((prevState) => prevState.setRequestResult(result));
      } catch (error: any) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
          console.log('Request canceled');
          return;
        }
        setState((prevState) => prevState.setRequestError(error));
      }
    },
    []
  );

  return {
    state,
    getAnnotations
  };
}
